import { APIClient } from '@/helpers/api_helper';

import type { AdminDashboardResponse } from '../types';

/**
 * Dashboards API client — thin wrapper around the shared axios `APIClient`.
 *
 * Endpoint mirrors the legacy `dashboardService.getAdminDashboard`:
 *   GET /Dashboard/Admin?limit={n}
 */
const ENDPOINT = '/Dashboard/Admin';
const api = new APIClient();

export function fetchAdminDashboard(
  limit?: number,
): Promise<AdminDashboardResponse> {
  const params: Record<string, string | number> = {};
  if (limit !== undefined && limit !== null) {
    params.limit = limit;
  }
  return api.get<AdminDashboardResponse>(ENDPOINT, params);
}
